import { useState } from "react";
import { useNavigate } from "react-router";
import Input from "../components/input";
import { fetchPosts } from "../aggregator";
import introPhoto from "../assets/images/intro-photo.png";
import introBackPhoto from "../assets/images/intro-background.png";
import t from "../locales";

export default function Dashboard({ setPosts }) {
  const navigate = useNavigate();
  const [groupCode, setGroupCode] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    const code = groupCode.trim();
    if (!code) {
      setError(t("dashboard.group-code.error"));
      return;
    }

    setError(null);
    setIsLoading(true);
    const posts = await fetchPosts(code);
    setIsLoading(false);

    if (posts === null) {
      setError(t("dashboard.error.other"));
      return;
    }
    if (posts.length === 0) {
      setError(t("dashboard.error.empty"));
      return;
    }

    setPosts(posts);
    navigate(`/dashboard/${encodeURIComponent(code)}`);
  }

  return (
    <form className="card card--dashboard" onSubmit={handleSubmit} noValidate>
      <title>{t("dashboard.page-title")}</title>
      <div className="card__photos">
        <div className="card__photo card__photo--back">
          <img className="card__image" src={introBackPhoto} alt="" />
        </div>
        <div className="card__photo card__photo--front">
          <img
            className="card__image"
            src={introPhoto}
            alt={t("intro.photo-alt")}
          />
        </div>
      </div>
      <div className="card__body">
        <div className="card__header">
          <h1 className="card__title">{t("dashboard.title")}</h1>
          <p className="card__description">{t("dashboard.description")}</p>
        </div>
        <Input
          id="group-code"
          label={t("dashboard.group-code.label")}
          placeholder={t("dashboard.group-code.placeholder")}
          value={groupCode}
          onChange={(value) => {
            setGroupCode(value);
            setError(null);
          }}
          error={error}
          autoFocus
          hideLabel
        />
        <button className="button" type="submit" disabled={isLoading}>
          {t("dashboard.submit")}
        </button>
      </div>
    </form>
  );
}
